import React from "react";

/*
 * Makes a whole table row open what the row is about.
 *
 * Only the small heading link in the first cell was clickable, so a row that
 * looked like a button did nothing anywhere else along its length — and on a
 * phone that link is a very small target.
 *
 * A click that lands on a link or a button inside the row belongs to that
 * control, not to the row: a results row carries its own links to the shot map,
 * and the row must not drag the reader somewhere else when they use one. A
 * click on text the reader is selecting is left alone too.
 */
export const rowClick = (go: () => void) => (e: React.MouseEvent<HTMLElement>) => {
  if ((e.target as HTMLElement).closest("a,button,input,select,label")) return;
  if (window.getSelection()?.toString()) return;
  go();
};

/** The same, for rows whose links open in a new tab — the row follows suit. */
export const rowClickNewTab = (href: string) => rowClick(() => window.open(href, "_blank", "noopener"));
